import React from "react";
import PropTypes from "prop-types";

import classNames from "classnames";

const Loading = ({ className }) => {
  const classes = classNames(
    "preloader-default",
    "d-flex",
    "justify-content-center",
    className
  );
  return (
    <div className={classes}>
      <div className="preloader-default__block">
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
};

Loading.defaultProps = {
  className: "",
};

Loading.propTypes = {
  className: PropTypes.string,
};

export default Loading;
